import { useParams } from 'react-router-dom';
import { useEmployeeUrl } from 'domain/shared/employee';
import { createRoute, useEntityUrl } from 'framework/routing';

const EMPLOYEE_OFFER_ID = 'employeeOfferId';
const EMPLOYEE_OFFER_PATH = '/offers';

export const useEmployeeOfferRoute = () => {
  return createRoute({
    listRoute: EMPLOYEE_OFFER_PATH,
    singleEntityRoute: `/:${EMPLOYEE_OFFER_ID}`,
  });
};

export const useEmployeeOfferUrl = () => {
  const { getSingleEntityUrl } = useEmployeeUrl();

  return useEntityUrl({
    baseLink: `${getSingleEntityUrl()}${EMPLOYEE_OFFER_PATH}`,
    idSource: EMPLOYEE_OFFER_ID,
  });
};

export const useEmployeeOfferId = () => useParams<Dictionary<string>>()[EMPLOYEE_OFFER_ID]!;
